import React from 'react'
import style from './AddToCartButton.module.scss'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'

interface IAddToCartButtonProps {
  quantity: number
  findability: boolean
  index: number
  limit: number
  onAddToCart: (qnt: -1 | 1, index: number) => void
}

const AddToCartButton = ({ quantity, findability, index, limit, onAddToCart }: IAddToCartButtonProps) => {
  const { t } = useSurveyLocale()
  return (
    <>
      {0 === quantity || findability ? (
        <button
          className={style.single}
          disabled={(quantity > 0 && findability) || (limit > 0 && quantity >= limit)}
          onClick={() => onAddToCart(1, index)}
        >
          {t('questions', 'ec', 'nike', 'addToCart')}
        </button>
      ) : (
        <div className={style.spin}>
          <button className={style.sign} onClick={() => onAddToCart(-1, index)}>
            {1 === quantity ? <div className={style.trashIcon} /> : <div className={style.minusIcon} />}
          </button>
          <div className={style.amount}>{quantity > 99 ? '99+' : quantity}</div>
          <button
            className={`${style.sign} ${limit > 0 && quantity >= limit ? style.disabled : ''}`}
            onClick={() => onAddToCart(1, index)}
          >
            <div className={style.plusIcon} />
          </button>
        </div>
      )}
    </>
  )
}
export default AddToCartButton
